import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from '@si-armes/dsfr-react';
import moment from 'moment';
import styles from './AfficherNotificationsDynamique.module.scss';
import { getLibelleFiltreByValue } from '../constants/notifications.constants';

const AfficherNotificationsDynamique = ({ notifications, supprimerNotificationParId }) => {
    const toStringFrenchDate = (date) => {
        return moment(date, 'YYYY-MM-DD hh:mm:sss').format('DD/MM/YYYY');
    };

    if (!notifications.length) {
        return <div>Aucune notification disponible...</div>;
    }

    return (
        <>
            {notifications.map((notification) => {
                let classNotification = styles.notification;

                if (!notification.supprimable) {
                    classNotification += ` ${styles.notification__nonSupprimable}`;
                }
                return (
                    <div key={notification.id} className={classNotification}>
                        <div>
                            <div className={styles.notification__description}>
                                {notification.description}
                            </div>
                            <div className={styles.notification__type}>
                                {toStringFrenchDate(notification.dateCreation)} -{' '}
                                {getLibelleFiltreByValue(notification.themeNotification)}
                            </div>
                        </div>
                        <div className={styles.notification__suppression}>
                            {notification.supprimable && (
                                <Button
                                    type="button"
                                    variant="secondary"
                                    icon="fr-fi-delete-line"
                                    onClick={() => {
                                        supprimerNotificationParId(notification.id);
                                    }}
                                    title="Supprimer la notification"
                                />
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

AfficherNotificationsDynamique.propTypes = {
    notifications: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            description: PropTypes.string.isRequired,
            dateCreation: PropTypes.string.isRequired,
            themeNotification: PropTypes.string.isRequired,
            supprimable: PropTypes.bool.isRequired,
        }),
    ),
    supprimerNotificationParId: PropTypes.func,
};

AfficherNotificationsDynamique.defaultProps = {
    notifications: [],
};

export default AfficherNotificationsDynamique;
